import { useState } from "react";
import type { FocusWithinProps } from "@react-aria/interactions";
import { useFocusWithin as useFocusWithinHook } from "@react-aria/interactions";
import noop from "lodash/noop";

export type UseFocusWithinProps = Omit<FocusWithinProps, "isDisabled">;

export const useFocusWithin = ({
  onFocusWithin = noop,
  onBlurWithin = noop,
  onFocusWithinChange = noop,
}: UseFocusWithinProps) => {
  const [isFocusWithin, setFocusWithin] = useState(false);

  const { focusWithinProps } = useFocusWithinHook({
    onFocusWithin,
    onBlurWithin,
    onFocusWithinChange: isFocusWithin => {
      setFocusWithin(isFocusWithin);
      onFocusWithinChange(isFocusWithin);
    },
  });

  return {
    isFocusWithin,
    focusWithinProps,
  };
};
